import {Color} from '@benchling/nucleus-ui';
import {MantineTheme, MantineThemeColors} from '@mantine/core';

import {EdgeStatus, STATUS_COLORS} from '../nodes/BenchlingNode/v2/BenchlingNodeV2Constants';
import {BaseEdgeRendererData, DEFAULT_EDGE_OPTIONS, LineStyle} from './edgeOptions';

const EDGE_SELECTION_COLOR = Color.BLUE_450;

/** @package */
export function getStrokeColor(
  theme: {
    colors: MantineThemeColors;
  },
  overrideColor?: string,
  status?: EdgeStatus,
  selected?: boolean
): string {
  if (selected) {
    return EDGE_SELECTION_COLOR;
  }
  if (status) {
    const statusColor = STATUS_COLORS[status];
    return theme.colors[statusColor.color][statusColor.colorIndex];
  }
  return overrideColor ?? DEFAULT_EDGE_OPTIONS.color;
}

export function getEdgePathStyle(
  theme: MantineTheme,
  data: BaseEdgeRendererData,
  selected: boolean
): React.CSSProperties {
  return {
    stroke: getStrokeColor(theme, data.color, data.status, selected),
    strokeWidth: '1.5px',
    strokeDasharray: data.lineStyle === LineStyle.DASHED ? '2 3' : undefined,
  };
}
